import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pd-wrapper" }
const _hoisted_2 = { class: "header-inner" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center py-8"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "summary-inner" }
const _hoisted_6 = { class: "summary-label" }
const _hoisted_7 = { class: "summary-inner" }
const _hoisted_8 = { class: "summary-label" }
const _hoisted_9 = { class: "chart-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DxPieLabel = _resolveComponent("DxPieLabel")!
  const _component_DxPieSeries = _resolveComponent("DxPieSeries")!
  const _component_DxPieLegend = _resolveComponent("DxPieLegend")!
  const _component_DxPieTooltip = _resolveComponent("DxPieTooltip")!
  const _component_DxPieAnimation = _resolveComponent("DxPieAnimation")!
  const _component_DxPieChart = _resolveComponent("DxPieChart")!
  const _component_DxCommonSeriesSettings = _resolveComponent("DxCommonSeriesSettings")!
  const _component_DxSeries = _resolveComponent("DxSeries")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxArgumentAxis = _resolveComponent("DxArgumentAxis")!
  const _component_DxLegend = _resolveComponent("DxLegend")!
  const _component_DxTooltip = _resolveComponent("DxTooltip")!
  const _component_DxAnimation = _resolveComponent("DxAnimation")!
  const _component_DxChart = _resolveComponent("DxChart")!
  const _component_EmptyChart = _resolveComponent("EmptyChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "header-card",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon dx-icon-group header-icon" }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "header-title" }, "Dashboard Personal"),
            _createElementVNode("div", { class: "header-subtitle" }, "KPI-uri angajați · distribuții · evoluție angajări")
          ], -1)),
          _createVNode(_component_v_btn, {
            class: "refresh-btn ml-auto",
            density: "compact",
            loading: _ctx.loading,
            onClick: _ctx.incarcaDashboard
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-refresh", -1)
                ]))]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" Actualizează ", -1))
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#ff5722",
            size: "48"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_row, {
            class: "mb-3",
            dense: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryCards1, (card, idx) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: card.key,
                  cols: "12",
                  sm: "6",
                  md: "4",
                  lg: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: _normalizeClass(["summary-card kpi-anim", card.alertClass]),
                      elevation: "0",
                      style: _normalizeStyle({ '--accent': card.color, 'animation-delay': (idx * 70) + 'ms' })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "summary-accent",
                          style: _normalizeStyle({ background: card.color })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", {
                            class: "summary-icon",
                            style: _normalizeStyle({ background: card.color + '1a' })
                          }, [
                            _createVNode(_component_v_icon, {
                              color: card.color,
                              size: "22"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(card.icon), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ], 4),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              class: "summary-value",
                              style: _normalizeStyle({ color: card.alert ? '#F44336' : '#1a202c' })
                            }, _toDisplayString(card.decimals ? _ctx.formatDec(_ctx.animated[card.key]) : Math.round(_ctx.animated[card.key] || 0)), 5),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(card.label), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "style"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: "mb-4",
            dense: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryCards2, (card, idx) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: card.key,
                  cols: "12",
                  sm: "6",
                  md: "4",
                  lg: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: _normalizeClass(["summary-card kpi-anim", card.alertClass]),
                      elevation: "0",
                      style: _normalizeStyle({ '--accent': card.color, 'animation-delay': ((_ctx.summaryCards1.length + idx) * 70) + 'ms' })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "summary-accent",
                          style: _normalizeStyle({ background: card.color })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", {
                            class: "summary-icon",
                            style: _normalizeStyle({ background: card.color + '1a' })
                          }, [
                            _createVNode(_component_v_icon, {
                              color: card.color,
                              size: "22"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(card.icon), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ], 4),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              class: "summary-value",
                              style: _normalizeStyle({ color: card.alert ? '#F44336' : '#1a202c' })
                            }, _toDisplayString(card.decimals ? _ctx.formatDec(_ctx.animated[card.key]) : Math.round(_ctx.animated[card.key] || 0)), 5),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(card.label), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "style"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleCharts, (chart, idx) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: chart.key,
                  cols: "12",
                  md: "6",
                  lg: chart.wide ? 12 : 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: _normalizeClass(["chart-card kpi-anim", { 'chart-card--wide': chart.wide }]),
                      elevation: "0",
                      style: _normalizeStyle({ 'animation-delay': (idx * 60) + 'ms' })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", {
                            class: "chart-header-icon",
                            style: _normalizeStyle({ background: chart.color + '1a' })
                          }, [
                            _createVNode(_component_v_icon, {
                              size: "15",
                              color: chart.color
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(chart.icon), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ], 4),
                          _createTextVNode(" " + _toDisplayString(chart.title), 1)
                        ]),
                        (chart.type === 'pie' && chart.data.length)
                          ? (_openBlock(), _createBlock(_component_DxPieChart, {
                              key: 0,
                              type: "doughnut",
                              "data-source": chart.data,
                              palette: chart.palette,
                              class: "chart-body"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPieSeries, {
                                  "argument-field": "Eticheta",
                                  "value-field": "Numar"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxPieLabel, {
                                      visible: true,
                                      format: "fixedPoint"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_DxPieLegend, {
                                  "vertical-alignment": "bottom",
                                  "horizontal-alignment": "center"
                                }),
                                _createVNode(_component_DxPieTooltip, { enabled: true }),
                                _createVNode(_component_DxPieAnimation, {
                                  enabled: true,
                                  duration: 1000,
                                  easing: "easeOutCubic"
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "palette"]))
                          : (chart.type === 'bar' && chart.data.length)
                            ? (_openBlock(), _createBlock(_component_DxChart, {
                                key: 1,
                                "data-source": chart.data,
                                class: "chart-body",
                                palette: chart.palette
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxCommonSeriesSettings, {
                                    "argument-field": chart.argField || 'Eticheta',
                                    type: "bar",
                                    "bar-padding": 0.3
                                  }, null, 8, ["argument-field"]),
                                  _createVNode(_component_DxSeries, {
                                    "value-field": "Numar",
                                    name: chart.seriesName || 'Angajați',
                                    color: chart.palette[0]
                                  }, null, 8, ["name", "color"]),
                                  _createVNode(_component_DxArgumentAxis, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxLabel, {
                                        "word-wrap": 'none',
                                        "overlapping-behavior": chart.rotate ? 'rotate' : 'none'
                                      }, null, 8, ["overlapping-behavior"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_DxLegend, { visible: false }),
                                  _createVNode(_component_DxTooltip, { enabled: true }),
                                  _createVNode(_component_DxAnimation, {
                                    enabled: true,
                                    duration: 1000,
                                    easing: "easeOutCubic"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["data-source", "palette"]))
                            : (chart.type === 'line' && chart.data.length)
                              ? (_openBlock(), _createBlock(_component_DxChart, {
                                  key: 2,
                                  "data-source": chart.data,
                                  class: "chart-body chart-body--wide",
                                  palette: chart.palette
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxCommonSeriesSettings, {
                                      "argument-field": chart.argField || 'Luna',
                                      type: "line"
                                    }, null, 8, ["argument-field"]),
                                    _createVNode(_component_DxSeries, {
                                      "value-field": "Numar",
                                      name: chart.seriesName || 'Angajări',
                                      color: chart.palette[0]
                                    }, null, 8, ["name", "color"]),
                                    _createVNode(_component_DxArgumentAxis, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxLabel, {
                                          "word-wrap": 'none',
                                          "overlapping-behavior": 'rotate'
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxLegend, { visible: false }),
                                    _createVNode(_component_DxTooltip, { enabled: true }),
                                    _createVNode(_component_DxAnimation, {
                                      enabled: true,
                                      duration: 1000,
                                      easing: "easeOutCubic"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["data-source", "palette"]))
                              : (_openBlock(), _createBlock(_component_EmptyChart, { key: 3 }))
                      ]),
                      _: 2
                    }, 1032, ["style", "class"])
                  ]),
                  _: 2
                }, 1032, ["lg"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
  ]))
}